export default __webpack_public_path__ + "static/media/robusto.98e2069f.png";